import React from 'react';
import styles from './PreviewNotification.scss';
export function PreviewNotification(props) {
    return (React.createElement("div", { className: styles.notification },
        React.createElement("h3", { className: styles.notificationBody }, "Esikatselu"),
        React.createElement("button", { className: styles.notificationClose, onClick: props.hidePreview }, "Sulje")));
}
